import { useEffect, useState, FC } from 'react';
import { Modal, Tag } from 'antd';
import { useRequest } from 'ahooks';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { PC_CDN_HOST } from '@/const/staticURL';
import { request } from '@/config/request';
import { isLogin } from '@/config/request/login';
import useModal from '@/components/NormalModal';
import './index.scss';
interface HistoryProps {
    show: boolean;
    changeParams: () => void;
}
const HistoryModal: FC<HistoryProps> = ({ show, changeParams }) => {
    const navigate = useNavigate();
    const [urlParams] = useSearchParams();
    const [ModalComponent, openModal, closeModal] = useModal();
    const login = isLogin();
    const { runAsync: apiGetKeywordHistory } = useRequest(
        request.goods.product.searchKeywordHistory,
        {
            manual: true
        }
    );
    const { runAsync: apiGetKeywordHot } = useRequest(
        request.goods.product.searchKeywordHot,
        {
            manual: true
        }
    );
    const { runAsync: apiDeleteHistory } = useRequest(
        request.goods.product.searchKeywordHistoryDelete,
        {
            manual: true
        }
    );
    const [historyList, setHistoryList] = useState<string[]>([]);
    const [hotList, setHotList] = useState<string[]>([]);
    useEffect(() => {
        if (!show) return;
        login &&
            apiGetKeywordHistory().then((res) => {
                setHistoryList(res?.data || []);
            });
        apiGetKeywordHot().then((res) => {
            setHotList(res?.data || []);
        });
    }, [apiGetKeywordHistory, apiGetKeywordHot, login, show]);
    const delHistory = () => {
        openModal({
            text: window._$m.t('确定要清空历史记录吗？'),
            onOk: async () => {
                const res = await apiDeleteHistory();
                if (res.success) {
                    setHistoryList([]);
                }
            }
        });
    };
    const tagRender = (list: string[]) => {
        return (
            <div>
                {list.length > 0 ? (
                    list.map((tag, index) => (
                        <Tag
                            className="search-tag"
                            key={index}
                            bordered={false}
                            onClick={() => {
                                navigate(
                                    `/goodsList?keyword=${tag}${
                                        urlParams.get(
                                            'productCategoryFrontendId'
                                        )
                                            ? `&productCategoryFrontendId=${urlParams.get(
                                                  'productCategoryFrontendId'
                                              )}&cateNameJp=${urlParams.get(
                                                  'cateNameJp'
                                              )}`
                                            : ''
                                    }`
                                );
                                changeParams();
                            }}
                        >
                            {tag}
                        </Tag>
                    ))
                ) : (
                    <div className="text-sm m-1.5 text-[#B0B7C2FF]">
                        {window._$m.t('暂无数据')}
                    </div>
                )}
            </div>
        );
    };
    return (
        <div
            className="w-[944px] bg-white rounded-md shadow-lg p-5 box-border absolute top-[130px]"
            style={{
                display: show ? 'block' : 'none'
            }}
        >
            {login && (
                <img
                    onClick={delHistory}
                    className="search-delete"
                    src={PC_CDN_HOST + 'search_delete.svg'}
                    alt=""
                />
            )}
            <div className="text-sm font-semibold m-1.5">
                {window._$m.t('搜索历史')}
            </div>
            <div>{tagRender(historyList)}</div>

            <div className="text-sm font-semibold m-1.5">
                {window._$m.t('人气搜索')}
            </div>
            <div>{tagRender(hotList)}</div>
            {!show && <ModalComponent />}
        </div>
    );
};
export default HistoryModal;
